import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { CsIconModule } from '@components/icon';
import { ReorderKitDetail } from '@cureskin/api-client/src/server-api';
import { ApiClientConstant } from '@cureskin/api-client/src/constant/api-client.constant';

@Component({
  selector: 'app-regimen-reorder-card',
  imports: [CsIconModule],
  templateUrl: './regimen-reorder-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegimenReorderCardComponent {
  reorderKit: InputSignal<ReorderKitDetail> = input.required<ReorderKitDetail>();
  regimenClass: InputSignal<string> = input.required<string>();
  showDoctorCharges: InputSignal<boolean> = input.required<boolean>();
  kitImage: InputSignal<string> = input.required<string>();

  readonly ApiClientConstant = ApiClientConstant;

  get isHairRegimen(): boolean {
    return this.regimenClass()?.toLowerCase() === ApiClientConstant.Regimen.Class.HAIR.toLowerCase();
  }
}
